import * as net from 'util/Net';

export function requestDemoFromProduct(demoType: string): JQueryPromise<{}> {
  return net.postJSON({
    url: '/1/api/contact:request-demo-from-product',
    data: {demoType},
  });
}
